import { render, staticRenderFns } from "./ClientOriginForm.vue?vue&type=template&id=35e3a9c4&scoped=true&"
import script from "./ClientOriginForm.vue?vue&type=script&lang=ts&"
export * from "./ClientOriginForm.vue?vue&type=script&lang=ts&"
import style0 from "./ClientOriginForm.vue?vue&type=style&index=0&id=35e3a9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3a9c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VContainer,VDivider,VForm,VIcon,VRow,VTextField})
